import Api from '@/api'

const api = new Api()

export default {
  async fetchWipSummary({ commit }, payload) {
    try {
      const resp = await api.finance().summary(payload)
      const response = resp.data.data
      commit('Dashboard/setFeedback', response, { root: true })
      commit('setFinance', response)
      return response
    } catch (err) {
      commit('Dashboard/setFeedback', { message: 'Invalid Request of WIP', errors: 500 }, { root: true })
    }
  },
  async fetchMonthlyWipSummary({ commit }, payload) {
    try {
      const resp = await api.finance().monthly(payload)
      const response = resp.data.data
      commit('Dashboard/setFeedback', response, { root: true })
      commit('setMonthly', response)
      return response
    } catch (err) {
      commit('Dashboard/setFeedback', { message: 'Invalid Request of Monthly WIP', errors: 500 }, { root: true })
    }
  },
}
